import { useMutation } from '@apollo/client';
import React from 'react';
import Form, { Field, Submit } from '../../components/Form';
import usePostLoginHandler from '../usePostLoginHandler';
import { gql } from '../../graphql/generated/gql';
import Link from '../../utils/router/Link';

const PASSWORD_LOGIN_MUTATION = gql(`
  mutation passwordLogin($email: String!, $password: String!) {
    session: passwordLogin(email: $email, password: $password) {
      authToken
    }
  }
`);

type LoginPasswordValues = { email: string; password: string };

const LoginPasswordFormView = () => {
  const [passwordLogin] = useMutation(PASSWORD_LOGIN_MUTATION);

  const postLoginHandler = usePostLoginHandler();

  const onSubmit = (values: LoginPasswordValues) =>
    passwordLogin({ variables: values }).then(({ data }) => {
      if (data?.session) {
        postLoginHandler(data.session.authToken);
      }
    });

  return (
    <Form<LoginPasswordValues>
      apiErrorMessages={{
        BAD_PASSWORD:
          'Email and password did not match. Did you mistype one of them?',
        SSO_ONLY: 'Please use Single Sign-On to log in.',
        UNVERIFIED_ORGANIZATION:
          'You need to verify your email before logging in.',
        USER_DEACTIVATED: 'This account has been deactivated.',
      }}
      initialValues={{ email: '', password: '' }}
      onSubmit={onSubmit}
    >
      {/* TODO: Multiple-token is valid but should double-check if it's expected here */}
      {/* eslint-disable-next-line jsx-a11y/autocomplete-valid */}
      <Field
        name="email"
        type="email"
        placeholder="Your email"
        required
        autoComplete="email username"
        margin="compact"
        inlineError
      />
      <Field
        name="password"
        type="password"
        placeholder="Password"
        required
        autoComplete="current-password"
        margin="compact"
        inlineError
      />
      <Submit block>Log in</Submit>
      <Link className="forgot-link" to="/forgot">
        Forgot your password?
      </Link>
    </Form>
  );
};

export default LoginPasswordFormView;
